import React, { useState } from "react";
import { AlertData } from "./login";
import { isValidEmail } from "../common/utils";
import axios from "axios";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Typography, Box, TextField, CircularProgress } from "@mui/material";
import { themeStatic } from "../scn/theme1";

interface ForgotPasswordProps {
  setPageToDisplay: React.Dispatch<React.SetStateAction<'login' | 'forgotPassword' | ''>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  alertData: AlertData | null;
  setAlertData: React.Dispatch<React.SetStateAction<AlertData | null>>;
}

export default function ForgotPassword(props: ForgotPasswordProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const emailErrorMessage = 'Veuillez entrer une adresse e-mail valide'
  const successMessage = 'Un email vient de vous être envoyé afin de réinitialiser votre mot de passe'
  const submitErrorMessage = 'Une erreur est survenue lors de la demande de réinitialisation du mot de passe'

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setButtonDisabled(true);
    props.setAlertData(null);

    try {
      // 1 - Check if email is a valid adress with regex 
      if (!isValidEmail(props.email)) {
        props.setAlertData({ message: emailErrorMessage, style: 'error' });
        setLoading(false);
        setButtonDisabled(false);
        return;
      }

      // 2 - Send email to server
      const response = await axios.post(
        '/emailpass',
        { email: props.email },
        { validateStatus: (status) => status < 500 }
      );

      if (response.status === 200) {
        props.setAlertData({ message: successMessage, style: "info" });
      } else if (response.status === 400) {
        props.setAlertData({ message: response.data, style: "error" });
      } else {
        props.setAlertData({ message: submitErrorMessage, style: "error" });
      }
    } catch (err) {
      props.setAlertData({ message: submitErrorMessage, style: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 1, color: themeStatic.palette.primary.main }}
        onClick={() => props.setPageToDisplay('login')}
      >
        Retour à la connexion
      </Button>
      <Typography
        gutterBottom
        sx={{ mt: 1, fontSize: 20 }}
      >
        Mot de passe oublié
      </Typography>

      <Typography
        gutterBottom
        sx={{ mt: 1, fontSize: 13, fontWeight: 100, opacity: 0.7 }}
      >
        Afin de créer un nouveau mot de passe, veuillez nous indiquer votre email de connexion.
      </Typography>


      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <TextField
          id="email"
          fullWidth
          label=""
          placeholder="Adresse e-mail"
          value={props.email}
          onChange={(e) => {
            props.setAlertData(null)
            props.setEmail(e.target.value)
          }}
          margin="normal"
          error={props.alertData !== null && props.alertData.message === emailErrorMessage}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: 3,
            mb: 2,
            py: 1.5,
            fontWeight: 'bold',
            borderRadius: '15px'
          }}
          color='primary'
          disabled={buttonDisabled}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          Valider
        </Button>
      </Box>
    </>
  )
}